// src/pages/Volunteer.js

import React from 'react';

const Volunteer = () => {
  return (
    <div>
      <div className='main'>
        <div className="column1"></div>
        <div className="column2">
          <br />
          <br />
          <div style={{ textAlign: 'center' }}>
            <h1>Volunteer</h1>
          </div>
          <p>
            VOLUNTEER WITH US
            We are always looking for volunteers to help with our open source projects, community events, and more. If you're interested in volunteering, please reach out to us at <a href="mailto:support@sabrenetics.com">support@sabrenetics.com</a>.
          </p>
          <p>
            FILMING
            COMING SOON
          </p>
          <p>
            SOCIAL WORK - BIOMEDICAL ENGINEERING VOLUNTEERING
            COMING SOON
          </p>
          <p>
            PROGRAMMERS - OPEN SOURCE PROJECTS
            Check out our open source projects on <a href="https://github.com/sabrenetics">GitHub</a>.
          </p>
      </div>
      <div className="column3"></div>
    </div>
    </div >
  );
};

export default Volunteer;
